import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import axiosInstance from "../config/axiosInstance";
import { API_ENDPOINTS } from "../config/apiConfig";
import "./PaymentStatus.css"; // We'll create this CSS file

const PaymentSuccess = () => {
    const [searchParams] = useSearchParams();
    const orderId = searchParams.get("order_id");
    const [status, setStatus] = useState({
        message: "Verifying payment...",
        isSuccess: null, // null for loading, true for success, false for failure
        orderDetails: null
    });

    useEffect(() => {
        const verifyPayment = async () => {
            try {
                console.log("Payment verification initiated for orderId:", orderId);

                const response = await axiosInstance.get(
                    `${API_ENDPOINTS.VERIFY_PAYMENT}?orderId=${orderId}`
                );

                console.log("Payment verification response:", response.data);

                const result = response.data;
                if (result.status === "PAID") {
                    setStatus({
                        message: "Payment Successful!",
                        isSuccess: true,
                        orderDetails: result.orderDetails
                    });
                } else {
                    setStatus({
                        message: "Payment Failed",
                        isSuccess: false,
                        orderDetails: result.orderDetails
                    });
                }
            } catch (error) {
                console.error("Error verifying payment:", error);
                setStatus({
                    message: "Error verifying payment",
                    isSuccess: false,
                    orderDetails: null
                });
            }
        };

        if (orderId) {
            verifyPayment();
        } else {
            setStatus({
                message: "No order ID provided",
                isSuccess: false,
                orderDetails: null
            });
        }
    }, [orderId]);

    const renderStatusIndicator = () => {
        if (status.isSuccess === null) {
            // Loading state
            return (
                <div className="status-loading">
                    <div className="loading-spinner"></div>
                </div>
            );
        } else if (status.isSuccess) {
            // Success state
            return (
                <div className="status-success">
                    <div className="success-circle">
                        <svg className="success-tick" viewBox="0 0 24 24">
                            <path
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                d="M6 12l4 4 8-8"
                            />
                        </svg>
                    </div>
                    <h2 className="status-message">{status.message}</h2>
                    {status.orderDetails && (
                        <div className="order-details">
                            <p>Order ID: {status.orderDetails.orderId}</p>
                            <p>Amount: ${status.orderDetails.amount}</p>
                            <p>Date: {new Date(status.orderDetails.date).toLocaleString()}</p>
                        </div>
                    )}
                </div>
            );
        } else {
            // Failed state
            return (
                <div className="status-failed">
                    <div className="failed-circle">
                        <svg className="failed-cross" viewBox="0 0 24 24">
                            <path
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                d="M6 6L18 18M6 18L18 6"
                            />
                        </svg>
                    </div>
                    <h2 className="status-message">{status.message}</h2>
                    <p className="failed-description">
                        {orderId ? "Please try again or contact support." : "Please check your order and try again."}
                    </p>
                </div>
            );
        }
    };

    return (
        <div className="payment-status-container">
            {renderStatusIndicator()}
        </div>
    );
};

export default PaymentSuccess;